function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React, { useState } from 'react';
import { StyleSheet } from 'react-native';
import { Input } from "../../../native";
import * as R from 'unitx/ramda';
import { useFormContext } from "../FormContext";

const TextWidget = ({
  id,
  readonly,
  disabled,
  label,
  value,
  onChange,
  onBlur,
  onFocus,
  autofocus,
  options,
  multiline,
  secureEntry,
  schema,
  formContext
}) => {
  const [focused, setFocused] = useState(false);
  const {
    mapping
  } = useFormContext(formContext);
  return /*#__PURE__*/React.createElement(Input, _extends({}, mapping.input, {
    style: [mapping.input.style, styles.input, multiline && styles.multiline, focused && styles.focused],
    multiline: multiline,
    placeholder: label,
    autoFocus: autofocus
  }, options, {
    editable: !disabled && !readonly,
    keyboardType: schema.type === 'number' ? 'numeric' : 'default',
    value: value ? value.toString() : '',
    secureTextEntry: secureEntry,
    onChangeText: newText => onChange(newText === '' ? options.emptyValue : newText),
    onBlur: R.pipe(() => setFocused(false), () => onBlur(id, value)),
    onFocus: R.pipe(() => setFocused(true), () => onFocus(id, value))
  }, options));
};

const styles = StyleSheet.create({
  input: {
    borderRadius: 4
  },
  multiline: {// minHeight: 100,
    // lineHeight: 22,
  },
  focused: {// borderColor: '#2c3e50',
  }
});
export default TextWidget;